export var AuthFormType;
(function (AuthFormType) {
    AuthFormType[AuthFormType["Registration"] = 0] = "Registration";
    AuthFormType[AuthFormType["Login"] = 1] = "Login";
})(AuthFormType || (AuthFormType = {}));
export var UserIdType;
(function (UserIdType) {
    UserIdType["Email"] = "Email";
    UserIdType["UserID"] = "UserID";
})(UserIdType || (UserIdType = {}));
//# sourceMappingURL=index.js.map